module.exports = __webpack_public_path__ + "img/ahrc-2018-landscape-logo-1200px.af8871ed.png";